<template>
	<div class="relative bg-white py-6 px-6 rounded-3xl w-64 my-4 shadow-xl">
		<div
			:class="type == 'HW' ? 'bg-green-500' : 'bg-blue-500'"
			class="text-white flex items-center absolute rounded-full py-5 px-5 shadow-xl left-4 -top-6">
			<span class="font-semibold">{{ type }}</span>
		</div>
		<div class="mt-8">
			<p class="text-xl text-left text-gray-800 font-semibold my-2">
				{{ title }}
			</p>
			<div class="flex space-x-2 text-gray-400 text-sm my-3">
				<!-- svg  -->
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="h-5 w-5"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
				</svg>
				<p>{{ date.substring(0, 10) }}</p>
			</div>
			<div class="border-t-2"></div>

			<a
				target="_blank"
				class="w-4/5 group mx-auto mt-4 flex items-center justify-center rounded-lg border border-current px-3 py-2 text-indigo-600 transition-colors hover:bg-indigo-600 focus:outline-none focus:ring active:bg-indigo-500"
				:href="report">
				<span class="font-medium transition-colors group-hover:text-white">
					Download
				</span>

				<span
					class="ml-4 flex-shrink-0 rounded-full border border-indigo-600 bg-white p-2 group-active:border-indigo-500">
					<svg
						class="h-4 w-4"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M17 8l4 4m0 0l-4 4m4-4H3" />
					</svg>
				</span>
			</a>
			<div
				:class="profilePage ? '' : 'hidden'"
				class="flex justify-between mt-4 space-x-3 md:mt-6">
				<div>
					<button
						v-on:click="toggleModal()"
						class="inline-flex items-center px-6 py-2 text-sm font-medium text-center text-gray-800 border border-gray-800 rounded-lg hover:border-gray-500 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
						Edit
					</button>
					<div
						v-if="showModal"
						v-on:click="toggleModal()"
						class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
						<div class="relative my-6 mx-auto max-w-6xl">
							<!--content-->
							<div
								@click.stop="() => {}"
								class="px-8 py-8 w-80 border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
								<!--header-->
								<div
									class="pb-4 flex items-center justify-between border-b border-solid border-slate-200 rounded-t">
									<h3 class="text-xl font-semibold">Add Black Book</h3>
									<button
										class="ml-auto bg-transparent border-0 text-black text-xl leading-none font-semibold outline-none focus:outline-none"
										v-on:click="toggleModal()">
										<span
											class="bg-transparent block outline-none focus:outline-none">
											X
										</span>
									</button>
								</div>
								<!--body-->
								<form
									class="space-y-4"
									@submit.prevent="handleSubmit()">
									<input
										v-model="title"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="text"
										autocomplete="on"
										placeholder="Project Title" />
									<input
										v-model="report"
										class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
										type="url"
										autocomplete="on"
										placeholder="Report URL" />
									<div>
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Date of Publication
										</h3>
										<input
											v-model="date"
											value="date"
											class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
											type="date"
											autocomplete="on" />
									</div>
									<div>
										<h3
											class="mb-1 font-semibold text-gray-900 dark:text-white">
											Project Type
										</h3>
										<ul
											class="w-full text-sm font-medium flex justify-between text-gray-900 bg-white rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
											<li
												class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
												<div class="flex items-center pl-3">
													<input
														id="list-radio-license"
														type="radio"
														v-model="type"
														value="SW"
														name="list-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="list-radio-license"
														class="py-3 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">
														Software
													</label>
												</div>
											</li>
											<li
												class="w-full rounded-t-lg border-b border-gray-200 dark:border-gray-600">
												<div class="flex items-center justify-end px-3">
													<input
														id="list-radio-id"
														type="radio"
														v-model="type"
														value="HW"
														name="list-radio"
														class="w-4 h-4 bg-gray-100 border-gray-300" />
													<label
														for="list-radio-id"
														class="py-3 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
														Hardware
													</label>
												</div>
											</li>
										</ul>
									</div>

									<div
										class="flex items-center justify-between border-t border-solid border-slate-200 rounded-b">
										<button
											class="text-purple-800 bg-transparent border border-solid border-purple-800 hover:bg-purple-800 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-4 py-3 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
											type="button"
											v-on:click="toggleModal()">
											Close
										</button>
										<button
											type="submit"
											class="flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
											Submit
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div
						v-if="showModal"
						class="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</div>
				<span
					@click="handleDelete()"
					class="inline-flex items-center px-5 py-2 text-sm font-medium cursor-pointer text-center text-gray-900 bg-red-400 bg-opacity-80 rounded-lg hover:bg-opacity-75 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700">
					Delete
				</span>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'

export default {
	name: 'BookCard',
	data() {
		return {
			showModal: false,
			profilePage: false
		}
	},
	methods: {
		toggleModal: function () {
			this.showModal = !this.showModal
		},
		async handleSubmit() {
			const data = {
				title: this.title,
				projectType: this.type,
				report: this.report,
				publishedOn: this.date
			}
			const res = await axios.put(`api/blackbook/${this.id}`, data)
			this.toggleModal()
			alert(res.data.message)
		},
		async handleDelete() {
			const res = await axios.delete(`api/blackbook/${this.id}`)
			if (res.status == 204) alert('Item deleted successfully')
			this.$router.go()
		}
	},
	mounted() {
		if (this.$route.name == 'profile') this.profilePage = true
	},
	props: {
		title: String,
		date: String,
		type: String,
		report: String,
		id: String
	}
}
</script>